import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '接口业务事务能力',
    type: 'BDLOGIC_2',
}
